export const BETA_FEEDBACK_RATINGS = ['dont-like-it', 'like-it', 'love-it'] as const;

export type BetaFeedbackRating = (typeof BETA_FEEDBACK_RATINGS)[number];

export const BETA_FEEDBACK_RATING_LABELS: Record<BetaFeedbackRating, string> = {
  'dont-like-it': "don't like it",
  'like-it': 'like it',
  'love-it': 'love it',
};

export const BETA_FEEDBACK_OBSERVATION_VALUE_BY_RATING: Record<BetaFeedbackRating, number> = {
  'dont-like-it': 0,
  'like-it': 1,
  'love-it': 2,
};

export const isBetaFeedbackRating = (value: unknown): value is BetaFeedbackRating => {
  return typeof value === 'string' && BETA_FEEDBACK_RATINGS.includes(value as BetaFeedbackRating);
};
